// src/hooks/useSearch.ts
import { useState, useEffect, useCallback } from 'react';
import { searchApi, type SearchParams, type SearchResult } from '../api/search';
import debounce from 'lodash/debounce';

export const useSearch = () => {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [categories, setCategories] = useState<string[]>([]);

  // Load categories on mount
  useEffect(() => {
    searchApi.getSearchCategories().then(setCategories).catch(console.error);
  }, []);

  // Debounced search function
  const performSearch = useCallback(
    debounce(async (params: SearchParams) => {
      if (!params.q.trim()) {
        setResults([]);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = await searchApi.advancedSearch(params);
        setResults(data.results);
      } catch (err: any) {
        setError(err.message || 'Search failed');
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 350),
    []
  );

  // Clear results
  const clearResults = () => {
    setResults([]);
    setError(null);
  };

  return {
    results,
    loading,
    error,
    categories,
    performSearch,
    clearResults
  };
};